import { InlineTextarea } from 'react-tinacms-inline';
import styled from 'styled-components';

const StyledInlineTextarea = styled(InlineTextarea)`
  text-transform: inherit;
`

export { StyledInlineTextarea as InlineTextarea };
